import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { ClientLookupOption } from '../models/client-lookup-option.model';

export interface IClientLookupRepository {
  search(term: string): Observable<readonly ClientLookupOption[]>;
  list(): Observable<readonly ClientLookupOption[]>;
}

export const CLIENT_LOOKUP_REPOSITORY = new InjectionToken<IClientLookupRepository>('IClientLookupRepository');
